import React, { useState } from "react";
import styled from "@emotion/styled";

const UKFlag = styled.div`
  width: 20px;
  height: 16px;
  overflow: hidden;
  position: relative;
`;

const USAFlag = styled.div`
  width: 20px;
  height: 16px;
  background: url(https://s3-alpha-sig.figma.com/img/6ca6/3f9b/00c891df815c7071fb3af40e61324e39?Expires=1745798400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=mYXw4XjVXap7CvlWluuf-QmIg5Y0b6wQeFd~7XQoKP1eky~C5uhobSsBcc0Y4busSgFMcr74aZA4msimBfsWSlu5~LGtAJLSg9VEN2BDKlneWTbNdZnZfkGIKrcSTTjyHF2KvtMmpICbSqkP7bxAKQfy0zv7EJ91u1JOmWZqcz9bsyiJVkVSq8MddOhHf4OIZZY9gvf5G~iR7GveCXuAtGlSObkX0XQ6Fcbf8h88ksgdfGKSaPY9g4hvIU9HrHaZgQZFFvgiD-CEXIlGkeJEADvdbtn9QIRSLJvuu6M1y-OJi82i3ZolqFeXpVhjISRUNZfEvuLpHDUY25EwcPs1Ng__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 2px;
`;

const Vector = styled.svg`
  width: 20px;
  height: 14px;
  position: absolute;
  left: 0px;
  top: 1px;
  right: 0px;
  bottom: 1px;
`;

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 999px;
  background: ${(props) =>
    props.isOpen ? "rgb(226, 232, 240)" : "rgb(241, 245, 249)"};
  padding: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgb(226, 232, 240);
  }
`;

const CountryText = styled.span`
  color: rgb(33, 37, 67);
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 110%;
`;

const ChevronUpIcon = styled.span`
  color: rgb(100, 116, 139);
`;

const ChevronDownIcon = styled.span`
  color: rgb(100, 116, 139);
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  display: flex;
  flex-direction: column;
  min-width: 130px;
  background: white;
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  padding: 16px;
  z-index: 1000;
`;

const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 0;
  border: none;
  background: none;
  cursor: pointer;
  opacity: ${(props) => (props.isSelected ? 1 : 0.4)};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;

const countries = [
  {
    code: "UK",
    name: "UK",
    flag: (
      <UKFlag>
        <Vector xmlns="http://www.w3.org/2000/svg">
          <path
            fill="rgb(0, 36, 125)"
            d="M0 2.255L0 4.44444L3.12667 4.44444L0 2.255ZM2.59111 14.4444L7.22222 14.4444L7.22222 11.2017L2.59111 14.4444ZM12.7778 11.2022L12.7778 14.4444L17.4083 14.4444L12.7778 11.2022ZM0 10L0 12.1894L3.12778 10L0 10ZM17.4094 0L12.7778 0L12.7778 3.24278L17.4094 0ZM20 12.19L20 10L16.8717 10L20 12.19ZM20 4.44444L20 2.255L16.8728 4.44444L20 4.44444ZM7.22222 0L2.59111 0L7.22222 3.24278L7.22222 0Z"
          />
        </Vector>
        <Vector xmlns="http://www.w3.org/2000/svg">
          <path
            fill="rgb(207, 27, 43)"
            d="M13.8794 9.93611L19.275 13.7144C19.5367 13.4483 19.7239 13.1133 19.825 12.7428L15.8167 9.93611L13.8794 9.93611ZM7.135 9.93611L5.94556 9.93611L0.550556 13.7139C0.84 14.0083 1.21111 14.2189 1.62722 14.3167L7.135 10.46L7.135 9.93611ZM12.6906 4.38056L13.88 4.38056L19.275 0.602778C18.9856 0.308333 18.615 0.0977778 18.1989 0L12.6906 3.85667L12.6906 4.38056ZM5.94556 4.38056L0.550556 0.602778C0.288889 0.869444 0.101667 1.20389 0 1.57444L4.00833 4.38056L5.94556 4.38056Z"
          />
        </Vector>
        <Vector xmlns="http://www.w3.org/2000/svg">
          <path
            fill="rgb(238, 238, 238)"
            d="M20 8.88889L11.6667 8.88889L11.6667 14.4444L12.7778 14.4444L12.7778 11.2022L17.4083 14.4444L17.7778 14.4444C18.3983 14.4444 18.9589 14.1883 19.3622 13.7783L13.9667 10L15.9039 10L19.9122 12.8067C19.9639 12.6194 20 12.4256 20 12.2222L20 12.19L16.8717 10L20 10L20 8.88889ZM0 8.88889L0 10L3.12778 10L0 12.1894L0 12.2222C0 12.8283 0.243889 13.3767 0.637778 13.7778L6.03278 10L7.22222 10L7.22222 10.5239L1.71444 14.38C1.87778 14.4189 2.04667 14.4444 2.22222 14.4444L2.59111 14.4444L7.22222 11.2017L7.22222 14.4444L8.33333 14.4444L8.33333 8.88889L0 8.88889ZM20 2.22222C20 1.61611 19.7561 1.06778 19.3622 0.666667L13.9672 4.44444L12.7778 4.44444L12.7778 3.92056L18.2861 0.0638888C18.1222 0.0255554 17.9533 0 17.7778 0L17.4094 0L12.7778 3.24278L12.7778 0L11.6667 0L11.6667 5.55556L20 5.55556L20 4.44444L16.8728 4.44444L20 2.255L20 2.22222ZM7.22222 0L7.22222 3.24278L2.59111 0L2.22222 0C1.60111 0 1.04111 0.256111 0.637778 0.666667L6.03278 4.44444L4.09556 4.44444L0.0872222 1.63833C0.0361111 1.82556 0 2.01889 0 2.22222L0 2.255L3.12667 4.44444L0 4.44444L0 5.55556L8.33333 5.55556L8.33333 0L7.22222 0Z"
          />
        </Vector>
        <Vector xmlns="http://www.w3.org/2000/svg">
          <path
            fill="rgb(207, 27, 43)"
            d="M11.6667 5.55556L11.6667 0L8.33333 0L8.33333 5.55556L0 5.55556L0 8.88889L8.33333 8.88889L8.33333 14.4444L11.6667 14.4444L11.6667 8.88889L20 8.88889L20 5.55556L11.6667 5.55556Z"
          />
        </Vector>
      </UKFlag>
    ),
  },
  {
    code: "USA",
    name: "USA",
    flag: <USAFlag />,
  },
];

const CountryDropdown = ({ value = "UK", onChange, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedCountry =
    countries.find((country) => country.code === value) || countries[0];

  const handleSelect = (countryCode) => {
    onChange?.(countryCode);
    setIsOpen(false);
  };

  return (
    <DropdownContainer {...props}>
      <DropdownButton onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
        {selectedCountry.flag}
        <CountryText>{selectedCountry.name}</CountryText>
        {isOpen ? (
          <ChevronUpIcon>
            <svg
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.46875 0.46875C6.75 0.1875 7.21875 0.1875 7.5 0.46875L13.5312 6.46875C13.8125 6.78125 13.8125 7.25 13.5312 7.53125C13.2188 7.84375 12.75 7.84375 12.4688 7.53125L7 2.0625L1.53125 7.53125C1.21875 7.84375 0.75 7.84375 0.46875 7.53125C0.15625 7.25 0.15625 6.78125 0.46875 6.5L6.46875 0.46875Z"
                fill="#64748B"
              />
            </svg>
          </ChevronUpIcon>
        ) : (
          <ChevronDownIcon>
            <svg
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.46875 7.53125L0.46875 1.53125C0.15625 1.25 0.15625 0.78125 0.46875 0.46875C0.75 0.1875 1.21875 0.1875 1.53125 0.46875L7 5.96875L12.4688 0.5C12.75 0.1875 13.2188 0.1875 13.5312 0.5C13.8125 0.78125 13.8125 1.25 13.5312 1.53125L7.5 7.53125C7.21875 7.84375 6.75 7.84375 6.46875 7.53125Z"
                fill="#64748B"
              />
            </svg>
          </ChevronDownIcon>
        )}
      </DropdownButton>

      {isOpen && (
        <DropdownMenu>
          {countries.map((country) => (
            <MenuItem
              key={country.code}
              onClick={() => handleSelect(country.code)}
              isSelected={country.code === value}
            >
              {country.flag}
              <CountryText>{country.name}</CountryText>
            </MenuItem>
          ))}
        </DropdownMenu>
      )}
    </DropdownContainer>
  );
};

export default CountryDropdown;
